// Imports

//=require jquery/dist/jquery.min.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require jquery-mask-plugin/dist/jquery.mask.min.js


$(window).on('load', function () {
    $('body').removeClass('is-loading')
});

//=require ../source/js/tools/tools.filter-input.js
//=require ../source/js/tools/tools.stop-transition-on-resize.js
//=require ../source/js/tools/tools.focus-on-keydown.js
//=require ../source/js/tools/tools.trap-focus.js
//=require ../source/js/tools/tools.go-to-element.js
//=require ../source/js/tools/tools-load-category-posts-json.js
//=require ../source/js/tools/tools.single.js

//=require css-element-queries/src/ResizeSensor.js

//=require ../source/js/components/components.input-filters.js
//=require ../source/js/components/components.site-header.js
//=require ../source/js/components/components.media-block.js
//=require ../source/js/components/components.tables.js
//=require ../source/js/components/components.faqs.js
//=require ../source/js/components/components.form.js
//=require ../source/js/components/components.search-list.js
//=require ../source/js/components/components.replace-hyphens.js
//=require ../source/js/components/components.osano.js
